<template>
    <div>
        <config-main-title>Permissões</config-main-title>

        <az-input
            type="text"
            icon="fa fa-search"
            ref="pesquisa"
            placeholder="Pesquisar..."
            v-model="search" />

        <az-empty-state class="mt-3" msg="Nenhum permissão identificada." v-if="!lista.length" />

        <template v-else>

            <table class="table table-sm border-0 table-responsive mt-3">
                <tr>
                    <td class="text-nowrap">
                        <a href="#" @click.prevent="filtrar(group)" v-for="(group, icx) in grupos" :key="icx">
                            <span class="badge badge-success mr-1" >
                                {{ group }}
                            </span>
                        </a>
                    </td>
                </tr>
            </table>

            <div v-for="(group, ig) in lista_grupos" :key="ig">
                    
                <az-break-title :title="ig" />
                
                <ul class="list-group mb-3">
                    <li class="list-group-item d-flex justify-content-between" v-for="(item, index) in group" :key="index">
                        <div>
                            {{ item.name }}
                            <span class="badge badge-secondary ml-2">#{{ item.id }}</span>
                        </div>
                        <div>
                            <span class="badge badge-secondary mr-2" v-if="item.acessos.length">{{ item.acessos.length }}</span>
                            <button type="button" class="btn btn-outline-secondary btn-sm" @click="acessos(item)">
                                <i class="fas fa-user-lock"></i>
                            </button>
                        </div>
                    </li>
                </ul>

            </div>

        </template>

        <edicao-acessos ref="acessos" @refresh="load()" baselog="permissoes" />

        <pre v-if="false">{{ lista }}</pre>

    </div>
</template>

<script>
import _ from 'lodash';
import AzBreakTitle from '../util/AzBreakTitle.vue';
import AzEmptyState from '../util/AzEmptyState.vue';
import EdicaoAcessos from './shared/EdicaoAcessos.vue';
import ConfigMainTitle from './shared/ConfigMainTitle.vue';
import AzInput from '../shared/forms/AzInput.vue';

export default {
    data () { 
        return { 
            dados: null, 
            search: "", 
        }
    },

    components: { 
        AzEmptyState,
        AzBreakTitle, 
        EdicaoAcessos,
        ConfigMainTitle,
        AzInput
    },
    
    computed: { 
        grupos: function () { 
            return _.uniq(
                _.map(this.lista, item => item.query_group.name)
            ).sort();
        },

        lista_grupos: function () { 
            return _.groupBy(this.lista, 'query_group.name');
        },

        lista: function () { 
            if ( !this.dados )
                return [];

            return _.sortBy(
                this.dados.filter(item => item.query_group_id != 9 || this.$store.state.unidade.suprimentos)
                   .filter(item => !this.search || JSON.stringify(item).toLowerCase().indexOf(this.search.toLowerCase()) >= 0),
                item => _.get(item, 'query_group.name') + '|' + _.get(item, 'name')
            );
        }
    },

    methods: { 
        filtrar (texto) { 
            if ( this.search == '"' + texto + '"' ) { 
                this.search = "";
            } else { 
                this.search = '"' + texto + '"';
            }
        },

        acessos(item) { 
          this.$refs.acessos.abrir('App\\Resource', item.id, item.name);
        },

        load() { 
            this.$util.load(this, { 
                service: 'permissoes',
                func: 'index',
                parms: { 
                    cadastro: true, 
                },
            });
        }
    },

    mounted() { 
        this.breadcrumb = [
            { name: "Configurações", path: "/cadastros"},
            { name: "Permissões", path: "/config/permissoes" },
        ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        this.$refs['pesquisa'].$refs.input.focus ();

        this.load();
    }
}
</script>